<template>
  <div class="certification-badge" :style="badgePositionStyle">
    <span class="certification-badge-content">
      {{ label }}
      <slot name="icon" :size="iconSize"></slot>
      <slot name="picture"></slot>
    </span>
  </div>
</template>

<script setup>
  import { computed, defineProps } from "vue";
  const props = defineProps({
    label: {
      type: String,
      default: "",
    },
    top: {
      type: [String, Number],
      default: "-15px",
    },
    right: {
      type: [String, Number],
      default: "-13px",
    },
    bottom: {
      type: [String, Number],
      default: "auto",
    },
    left: {
      type: [String, Number],
      default: "auto",
    },
    color: {
      type: String,
      default: "#ff2c55 ",
    },
    fontSize: {
      type: [String, Number],
      default: "15px",
    },
    iconSize: {
      type: [String, Number],
      default: "20px",
    },
  });
  const badgePositionStyle = computed(() => {
    return {
      top: typeof props.top === "number" ? `${props.top}px` : props.top,
      right: typeof props.right === "number" ? `${props.right}px` : props.right,
      bottom: typeof props.bottom === "number" ? `${props.bottom}px` : props.bottom,
      left: typeof props.left === "number" ? `${props.left}px` : props.left,
      "--c": props.color,
      fontSize: typeof props.fontSize === "number" ? `${props.fontSize}px` : props.fontSize,
    };
  });
</script>

<style lang="scss" scoped>
  .certification-badge {
    --r: 0.6em;
    position: absolute;
    z-index: 1;

    &-content {
      display: flex;
      align-items: center;
      gap: 8px;
      line-height: 1.8;
      padding: 0 0.5em calc(2 * var(--r)) !important;
      border-radius: 0 var(--r) var(--r) 0 !important;
      background:
        radial-gradient(100% 50% at right, var(--c) 98%, #0000 101%) 0 0 / 15px calc(100% - 2 * var(--r)),
        radial-gradient(100% 50% at left, #0005 98%, #0000 101%) 100% 100% / var(--r) calc(2 * var(--r)),
        conic-gradient(from 180deg at calc(100% - var(--r)) calc(100% - 2 * var(--r)), #0000 25%, var(--c) 0) 100% 0 / calc(101% - 15px) 100% !important;
      background-repeat: no-repeat !important;
      color: #fff;
      font-weight: 800;
      line-height: 30px;
    }
  }
</style>
